// extracted by mini-css-extract-plugin
export default {"foundation":"NextSteps_foundation__LcR8S","container":"NextSteps_container__T-yD7","innerContainer":"NextSteps_innerContainer__JkMwZ","boxs":"NextSteps_boxs__tQbzc"};